/* Cold Break Brewing — shared site behaviour
   Scroll/timer based (no IntersectionObserver / rAF dependency) so it works
   in every browser and degrades gracefully. */
(function () {
  "use strict";

  var nav = document.querySelector(".nav");
  var progress = document.getElementById("progress");
  var revealEls = [].slice.call(document.querySelectorAll(".reveal"));
  var pints = [].slice.call(document.querySelectorAll(".pint"));
  var counters = [].slice.call(document.querySelectorAll("[data-count]"));

  /* ---- Mobile nav ---- */
  var burger = document.getElementById("burger");
  if (burger)
    burger.addEventListener("click", function () {
      document.body.classList.toggle("nav-open");
    });
  var links = document.querySelector(".nav__links");
  if (links)
    links.addEventListener("click", function (e) {
      if (e.target.tagName === "A") document.body.classList.remove("nav-open");
    });

  /* ---- Count-up (timer based) ---- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute("data-count")) || 0;
    var dec = parseInt(el.getAttribute("data-dec") || "0", 10);
    var dur = 1300,
      t0 = null;
    var iv = setInterval(function () {
      if (t0 === null) t0 = performance.now();
      var p = Math.min((performance.now() - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toFixed(dec);
      if (p >= 1) {
        el.textContent = target.toFixed(dec);
        clearInterval(iv);
      }
    }, 16);
  }

  function inView(el, margin) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight - margin && r.bottom > 0;
  }

  /* ---- Master scroll/sync handler ---- */
  function sync() {
    var y = window.scrollY || document.documentElement.scrollTop;
    if (nav) nav.classList.toggle("nav--scrolled", y > 20);
    if (progress) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = (h > 0 ? (y / h) * 100 : 0) + "%";
    }
    revealEls.forEach(function (el) {
      if (inView(el, 80)) el.classList.add("in");
    });
    pints.forEach(function (el) {
      if (inView(el, 60)) el.classList.add("is-filling");
    });
    counters.forEach(function (el) {
      if (!el._counted && inView(el, 40)) {
        el._counted = true;
        countUp(el);
      }
    });
  }
  window.addEventListener("scroll", sync, { passive: true });
  window.addEventListener("resize", sync);
  // run now and shortly after, so above-the-fold content is shown immediately
  sync();
  setTimeout(sync, 60);
  window.addEventListener("load", sync);

  /* ---- Book a Table form ---- */
  var form = document.getElementById("bookform");
  if (form) {
    var isEvent = /events/i.test(document.body.getAttribute("data-page") || "");
    var dateField = form.querySelector('input[type="date"]');
    var timeField = form.querySelector('input[type="time"]');
    // Table bookings need 24h notice; events can be any future date.
    var LEAD_MS = isEvent ? 0 : 24 * 60 * 60 * 1000;
    function setMinDate() {
      var d = new Date(Date.now() + LEAD_MS);
      dateField.min = d.toISOString().slice(0, 10);
    }
    if (dateField) {
      setMinDate();
      ["focus", "input"].forEach(function (ev) {
        dateField.addEventListener(ev, function () {
          dateField.setCustomValidity("");
        });
      });
      if (timeField)
        timeField.addEventListener("input", function () {
          dateField.setCustomValidity("");
        });
    }
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (dateField) dateField.setCustomValidity("");
      // Enforce all required fields (name, party, date, time, phone, email) natively
      if (form.checkValidity && !form.checkValidity()) {
        form.reportValidity();
        return;
      }
      // Enforce 24-hour notice for table bookings
      if (LEAD_MS && dateField && timeField) {
        var when = new Date(dateField.value + "T" + (timeField.value || "00:00"));
        if (!isNaN(when.getTime()) && when.getTime() - Date.now() < LEAD_MS) {
          dateField.setCustomValidity(
            "Online bookings need at least 24 hours' notice. For a same-day table, please call the brewery at 647-581-4009."
          );
          dateField.reportValidity();
          return;
        }
      }
      var data = {
        name: form.elements["name"].value.trim(),
        party: form.elements["party"].value,
        date: form.elements["date"].value,
        time: form.elements["time"].value,
        phone: form.elements["phone"].value.trim(),
      };

      // Send the submission to events@coldbreak.ca (FormSubmit — no backend needed)
      var isEvent = /events/i.test(document.body.getAttribute("data-page") || "");
      var fd = new FormData(form);
      fd.append("_subject", (isEvent ? "New Event Enquiry" : "New Table Booking") + " — coldbreak.ca");
      fd.append("_template", "table");
      // Table bookings (12 or under) also CC Reagan, since events@ isn't checked often.
      // Event enquiries and large parties (12+) still go to events@coldbreak.ca only.
      if (!isEvent && data.party !== "12+") fd.append("_cc", "Reagan_buckley@hotmail.com");
      fd.append("_captcha", "false");
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn._label = btn._label || btn.textContent; btn.disabled = true; btn.textContent = "Sending…"; }
      var errBox = document.getElementById("bookerror");
      if (errBox) errBox.hidden = true;

      function showConfirmed() {
        var ok = document.getElementById("bookconfirm");
        var pn = document.getElementById("c-name");
        var pd = document.getElementById("c-detail");
        if (pn) pn.textContent = data.name;
        if (pd) pd.textContent = "Party of " + data.party + " · " + data.date + " at " + data.time + ".";
        form.hidden = true;
        if (ok) { ok.hidden = false; ok.scrollIntoView({ behavior: "smooth", block: "center" }); }
      }
      function showFailed() {
        // Do NOT tell the guest they're booked if we couldn't actually send it.
        if (btn) { btn.disabled = false; btn.textContent = btn._label || "Book My Table"; }
        if (errBox) { errBox.hidden = false; errBox.scrollIntoView({ behavior: "smooth", block: "center" }); }
        else alert("Sorry — we couldn't submit that. Please email events@coldbreak.ca or call 647-581-4009 to book.");
      }

      fetch("https://formsubmit.co/ajax/events@coldbreak.ca", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: fd,
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          // Only confirm when FormSubmit actually accepted it.
          if (res && (res.success === "true" || res.success === true)) showConfirmed();
          else showFailed();
        })
        .catch(function () { showFailed(); });
    });
    var again = document.getElementById("bookagain");
    if (again)
      again.addEventListener("click", function () {
        document.getElementById("bookconfirm").hidden = true;
        var eb = document.getElementById("bookerror");
        if (eb) eb.hidden = true;
        form.hidden = false;
        form.reset();
        var b = form.querySelector('button[type="submit"]');
        if (b && b._label) { b.disabled = false; b.textContent = b._label; }
      });
  }

  /* ---- Newsletter popup ---- */
  var pop = document.getElementById("cbpop");
  if (pop) {
    var KEY = "cb_pop_v1";
    var joined = !!pop.querySelector(".cbpop__done"); // server-rendered success
    function openPop() {
      pop.hidden = false;
      document.body.classList.add("cbpop-open");
    }
    function closePop() {
      pop.hidden = true;
      document.body.classList.remove("cbpop-open");
      try { localStorage.setItem(KEY, "closed"); } catch (e) {}
    }
    if (joined) {
      openPop();
      try { localStorage.setItem(KEY, "joined"); } catch (e) {}
    } else {
      var seen = null;
      try { seen = localStorage.getItem(KEY); } catch (e) {}
      if (!seen) setTimeout(openPop, 6000);
    }
    pop.addEventListener("click", function (e) {
      if (e.target.hasAttribute("data-cbclose")) closePop();
    });
    document.addEventListener("keydown", function (e) {
      if ((e.key === "Escape" || e.keyCode === 27) && !pop.hidden) closePop();
    });
    var pf = pop.querySelector("form");
    if (pf)
      pf.addEventListener("submit", function () {
        try { localStorage.setItem(KEY, "joined"); } catch (e) {}
      });
  }

  /* ---- Footer year ---- */
  var yr = document.getElementById("year");
  if (yr) yr.textContent = new Date().getFullYear();
})();
